import React, { Component } from "react";
import { Form, Segment, Checkbox, Header } from "semantic-ui-react";
import { Field } from "redux-form";

class PreciosForm extends Component {
  renderDetalle = opcion => {
    const claves = Object.keys(opcion);
    const valor = Object.values(opcion);

    const items = [];
    claves.forEach((clave, index) => {
      if (clave !== "horario" && clave !== "nombre" && clave !== "key") {
        items.push(
          <div key={`${valor[index].nombre} - ${valor[index].precio}`}>
            <label>{`${valor[index].nombre} - ${valor[index].precio} €`}</label>
          </div>
        );
      }
    });
    return items;
  };

  renderCheck = field => {
    return (
      <React.Fragment>
        <Header as="h2">
          <Checkbox
            label={`${field.opcion.nombre} ${field.opcion.horario}`}
            onChange={(e, { checked }) =>
              field.input.onChange(checked ? field.opcion : null)
            }
          />
        </Header>
        <Header as="h4">Opciones</Header>
        {this.renderDetalle(field.opcion)}
      </React.Fragment>
    );
  };

  renderOpciones = valores =>
    valores.map(opcion => (
      <Field
        key={`${opcion.key}_${opcion.nombre}`}
        name={opcion.key}
        component={this.renderCheck}
        opcion={opcion}
      />
    ));

  render(props) {
    return (
      <Segment.Group horizontal>
        <Segment vertical basic>
          <Header as="h2">Sin Comedor</Header>
          <Form>{this.renderOpciones(this.props.sinComedor)}</Form>
        </Segment>
        <Segment vertical basic>
          <Header as="h2">Con Comedor</Header>
          <Form>{this.renderOpciones(this.props.conComedor)}</Form>
        </Segment>
      </Segment.Group>
    );
  }
}
export default PreciosForm;



// WEBPACK FOOTER //
// ./src/pages/escuelas/buscadores/colegios/modalAsignacion/PreciosForm.jsx